import { WarehouseReportData } from "../types"

export function getOrdersTotal(report: WarehouseReportData): number {
    return Object.values(report.orders).reduce((prev, cur) => (prev + cur.length), 0)
}